import { gql } from '@efficiently/client-core-graphql-models';

export const PROJECT_DESIGN_CHANGE_DETAIL_FIELDS = gql(`
	fragment ProjectDesignChangeDetail on ProjectDesignChange {
		...ProjectDesignChange
		items {
			...ProjectDesignChangeItemDisplay
		}
		documents {
			contentId
			fileName
			url
			size
			mimeType
		}
	}
`);
